import React from 'react';

import { useTranslation } from '@wix/yoshi-flow-editor';
import { Divider, Text } from '@wix/wix-ui-tpa/cssVars';

import { st, classes } from './NewMessagesDivider.st.css';

export const NewMessagesDivider: React.FC<{
  label?: string;
  dateLabel?: string;
}> = ({ label, dateLabel }) => {
  const { t } = useTranslation();
  const content = label ?? t('app.widget.chat.newMessagesDivider');

  return (
    <div className={st(classes.root)} role="separator" aria-label={content}>
      <div className={st(classes.content)}>
        {!!dateLabel && (
          <>
            <div className={st(classes.line)}>
              <Divider className={st(classes.divider)} />
            </div>
            <Text className={st(classes.label)}>{dateLabel}</Text>
            <div className={st(classes.line)}>
              <Divider className={st(classes.divider)} />
            </div>
            <Text className={st(classes.label)}>{content}</Text>
          </>
        )}

        {!dateLabel && (
          <>
            <div className={st(classes.line)}>
              <Divider className={st(classes.divider)} />
            </div>
            <Text className={st(classes.label)}>{content}</Text>
          </>
        )}
      </div>
    </div>
  );
};
